import * as React from "react";
import { Button, Modal, Typography, Stack, Box, Grid, useMediaQuery } from "@mui/material";
import CloseModalIcon from "../../icons/RoundCloseIcon.svg";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import AddBankBgImage from "../../icons/addBankBgImage.png";
import AddBankIcon from "../../icons/AddBankIcon.png";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useDispatch, useSelector } from "react-redux";
import { getUpdateBankAccount, getDeleteBankAccount, selectPaymentState, getPaymentMethods, clearBankAndCardStates } from "../../resui/payments/sagas/residentpaymentsSlice";
import { makeStyles } from "@mui/styles";
import SpinnerModal from "../../shared/Modal/SpinnerModal";
import { approvedISOStandards } from "../util/approvedISOStandards";
import { setDeleteBankAccountRequest, setUpdateBankAccountRequest, DEFAULT_ADHOC_BANK_UUID } from "../../pmui/residents/saga/pmResidentsSlice";

const useStyles = makeStyles((theme) => ({
  globalError: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "100%",
  },
  wrapper: {
    margin: "1px",
    position: "relative",
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  cardContainer: {
    width: "100% !important",
  },
}));
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#FFFFFF",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
};

export default function UpdateCardPaymentModal(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");
  const matches380 = useMediaQuery("(max-width:380px)");
  const [isEdit, setIsEdit] = React.useState(true);
  const [nickName, setNickName] = React.useState(props.nickName);
  const [bankAddress, setBankAddress] = React.useState(props?.billingAddress ? props?.billingAddress?.Line1 : "");
  const [bankCity, setBankCity] = React.useState(props?.billingAddress ? props?.billingAddress?.City : "");
  const [bankState, setBankState] = React.useState(props?.billingAddress ? props?.billingAddress?.State : "");
  const [bankZip, setBankZip] = React.useState(props?.billingAddress ? props?.billingAddress?.Zip : "");
  const [bankCountry, setBankCountry] = React.useState(props?.billingAddress ? props?.billingAddress?.Country : "");
  const [bankAddressError, setBankAddressError] = React.useState("");
  const [bankZipError, setBankZipError] = React.useState("");
  const [bankCountryError, setBankCountryError] = React.useState("");
  const [bankCityError, setBankCityError] = React.useState("");
  const [bankStateError, setBankStateError] = React.useState("");
  const [disableBankSubmit, setDisableBankSubmit] = React.useState(true);
  const [bankGlobalError, setBankGlobalError] = React.useState<string | null>(null);
  const { isFetching, isBankEditedSuccess, isError, bankErrorMessage, isBankDeleted } = useSelector(selectPaymentState);
  const [isSpinnerModalOpen, setIsSpinnerModalOpen] = React.useState(false);
  const [spinnerStatus, setSpinnerStatus] = React.useState<string | null>(null);

  const { Countries: approvedCountries, States: approvedStates, Provinces: approvedProvinces } = approvedISOStandards;
  const validateBankAddress = () => {
    if (bankAddress.length === 0) {
      setBankAddressError("Bank address is empty!");
      return false;
    } else {
      setBankAddressError("");
      return true;
    }
  };
  const validateBankZip = () => {
    if (bankZip.length === 0) {
      setBankZipError("Bank ZIP code is empty!");
      return false;
    } else {
      setBankZipError("");
      return true;
    }
  };
  const validateBankCountry = () => {
    if (bankCountry.length === 0) {
      setBankCountryError("Bank country is empty!");
      return false;
    } else {
      setBankCountryError("");
      return true;
    }
  };
  const validateBankCity = () => {
    if (bankCity.length === 0) {
      setBankCityError("Bank city is empty!");
      return false;
    } else {
      setBankCityError("");
      return true;
    }
  };
  const validateBankState = () => {
    if (bankState.length === 0) {
      setBankStateError("Bank state is empty!");
      return false;
    } else {
      setBankStateError("");
      return true;
    }
  };
  const disableBankBtn = () => {
    if (bankAddress.length === 0 || bankCountry.length === 0 || bankCity.length === 0 || bankState.length === 0 || bankZip.length === 0) {
      setDisableBankSubmit(true);
    } else {
      setDisableBankSubmit(false);
    }
  };
  const handleEdit = () => {
    setIsEdit(false);
  };
  const [alignment, setAlignment] = React.useState("checking");
  const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment);
  };
  React.useEffect(() => {
    if (bankAddress.length === 0 || bankCountry.length === 0 || bankCity.length === 0 || bankState.length === 0 || bankZip.length === 0) {
      setDisableBankSubmit(true);
    } else {
      setDisableBankSubmit(false);
    }
  }, [bankAddress, bankCountry, bankCity, bankState, bankZip]);

  const updateBankHandler = () => {
    dispatch({
      type: clearBankAndCardStates.type,
    });

    if (validateBankAddress() && validateBankCity() && validateBankState() && validateBankZip() && validateBankCountry()) {
      props.uuid !== DEFAULT_ADHOC_BANK_UUID && setIsSpinnerModalOpen(true); // no need for spinner if we are fetching payment methods from app context
      dispatch({
        type: props.uuid === DEFAULT_ADHOC_BANK_UUID ? setUpdateBankAccountRequest.type : getUpdateBankAccount.type,
        payload: {
          NickName: nickName,
          BillingAddress: {
            City: bankCity,
            State: bankState,
            Zip: bankZip,
            Line1: bankAddress,
            Country: bankCountry,
          },
        },
        bankaccountUuid: props.uuid === DEFAULT_ADHOC_BANK_UUID ? undefined : props.uuid,
      });

      props.uuid === DEFAULT_ADHOC_BANK_UUID && props.handleClose && props.handleClose();
    }
  };

  const deleteBankHandler = () => {
    props.uuid !== DEFAULT_ADHOC_BANK_UUID && setIsSpinnerModalOpen(true);
    dispatch({
      type: props.uuid === DEFAULT_ADHOC_BANK_UUID ? setDeleteBankAccountRequest.type : getDeleteBankAccount.type,
      bankaccountUuid: props.uuid === DEFAULT_ADHOC_BANK_UUID ? undefined : props.uuid,
    });

    props.uuid === DEFAULT_ADHOC_BANK_UUID && props.handleClose && props.handleClose();
  };

  const handleCloseSpinnerModal = React.useCallback(() => {
    setIsSpinnerModalOpen(false);
    dispatch(getPaymentMethods());
  }, [dispatch, getPaymentMethods]);

  React.useEffect(() => {
    if (isBankDeleted || isBankEditedSuccess) {
      setSpinnerStatus("stop");
    }
    if (isError) {
      setBankGlobalError(bankErrorMessage);
      setIsSpinnerModalOpen(false);
    }
  }, [isBankDeleted, isBankEditedSuccess, isError, handleCloseSpinnerModal, bankErrorMessage, props]);

  React.useEffect(() => {
    setBankGlobalError(null);
    return () => {
      setBankGlobalError(null);
    };
  }, []);

  return (
    <div>
      <Modal open={props.open} onClose={props.handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box 
          sx={{
            ...style,
            width: matches380 ? "100%": "472px",
            minHeight: matches380 ? "100%": "610px",
            borderRadius: matches380 ? "none": "24px",
            p: matches380 ? 2: 4,
          }} 
          component="form" 
          noValidate
        >
          <Stack direction="column" justifyContent="start" alignItems="space-between" spacing={2}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <ArrowBackRoundedIcon
                  sx={{ color: "#39A2DB", height: 30, width: 30, cursor: "pointer", marginLeft: "20px" }}
                  onClick={() => {
                    props.handleClose();
                    setNickName(props.nickName);
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography id="payment-method-title" style={{ textAlign: "center" }}>
                  Add Bank Account
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <img
                  src={CloseModalIcon}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    props.handleClose();
                    setNickName(props.nickName);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                {bankGlobalError?.length ? (
                  <Typography
                    style={{
                      fontFamily: "'Open Sans', sans-serif",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: "#DB3939",
                      textAlign: "center",
                      borderTop: "2px  solid #DB3939",
                      borderRadius: "24px",
                      padding: "12px 20px",
                      width: "340px",
                      margin: "0px auto",
                    }}
                  >
                    {bankGlobalError}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            {/* <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <div>
                <ArrowBackRoundedIcon
                  sx={{ color: "#39A2DB", height: 30, width: 30, cursor: "pointer" }}
                  onClick={() => {
                    props.handleClose();
                    setNickName(props.nickName);
                  }}
                />
              </div>
              <div>
                <Typography id="payment-method-title">Add Bank Account</Typography>
              </div>
              <div>
                <img
                  src={CloseModalIcon}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    props.handleClose();
                    setNickName(props.nickName);
                  }}
                />
              </div>
            </Stack> */}
            <React.Fragment>
              {/* {bankGlobalError?.length ? (
                <div className={classes.globalError}>
                  <Typography
                    style={{
                      fontFamily: "'Open Sans', sans-serif",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: "#DB3939",
                    }}
                  >
                    {bankGlobalError}
                  </Typography>
                </div>
              ) : (
                ""
              )} */}
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="space-between"
                spacing={2}
                style={{
                  backgroundImage: "url(" + AddBankBgImage + ")",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: matches380 ? "calc( 100% - 5px) 211px": "345px 211px",
                  height: "210px",
                  width: matches380 ? "100%": "350px",
                  padding: "16px",
                  margin: "0 auto",
                }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                  <div>
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: "#14142B",
                      }}
                    >
                      Bank account
                    </Typography>
                  </div>
                  <div>
                    <img src={AddBankIcon} alt="card" style={{ width: "16px", height: "15px" }} />
                  </div>
                </Stack>
                <div>
                  <Typography>{props.bankName}</Typography>
                </div>
                <div>
                  <Typography>{props.names}</Typography>
                </div>
                <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={4}>
                  <div>
                    <Typography>Account Number</Typography>
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: "#14142B",
                      }}
                    >
                      <div style={{ background: "#14142B", borderRadius: "4px", width: 7, height: 7, display: "inline-block", marginRight: "2px" }}></div>
                      <div style={{ background: "#14142B", borderRadius: "4px", width: 7, height: 7, display: "inline-block", marginRight: "2px" }}></div>
                      <div style={{ background: "#14142B", borderRadius: "4px", width: 7, height: 7, display: "inline-block", marginRight: "2px" }}></div>
                      <div style={{ background: "#14142B", borderRadius: "4px", width: 7, height: 7, display: "inline-block", marginRight: "3px" }}></div>
                      {props.accountLastFour}
                    </Typography>
                  </div>
                  <div style={{ marginBottom: "5px" }}>
                    <Typography>Routing Number</Typography>
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: "#14142B",
                      }}
                    >
                      {" "}
                      {props.routingNumber}
                    </Typography>
                  </div>
                </Stack>
              </Stack>

              <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                {/* <div className={classes.cardContainer}> */}
                <input
                  placeholder="Nickname"
                  style={{
                    border: "1px solid #F1F0F5",
                    fontFamily: "'Open Sans', sans-serif",
                    borderRadius: "24px",
                    height: "36px",
                    width: matches380 ? "50%": "170px",
                    padding: "10px",
                  }}
                  disabled={isEdit}
                  value={nickName}
                  onChange={(e: any) => setNickName(e.target.value)}
                />
                {/* </div> */}
                <ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} style={{ width: "170px" }}>
                  <ToggleButton
                    value="checking"
                    style={{
                      fontFamily: "'Work Sans', sans-serif",
                      width: "50%",
                      border: "1px solid #F1F0F5",
                      borderRadius: "24px 0 0 24px ",
                      background: props.accountType === "C" ? "#F1F0F5" : "#fff",
                      color: "#14142B",
                      textTransform: "capitalize",
                      fontSize: "12px",
                      lineHeight: "22px",
                    }}
                    size="small"
                    disabled
                  >
                    Checking
                  </ToggleButton>
                  <ToggleButton
                    value="savings"
                    style={{
                      width: "50%",
                      fontFamily: "'Work Sans', sans-serif",
                      border: "1px solid #F1F0F5",
                      borderRadius: "0 24px 24px 0 ",
                      background: props.accountType === "S" ? "#F1F0F5" : "#fff",
                      color: "#14142B",
                      textTransform: "capitalize",
                      fontSize: "12px",
                      lineHeight: "22px",
                    }}
                    size="small"
                    disabled
                  >
                    Savings
                  </ToggleButton>
                </ToggleButtonGroup>
              </Stack>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <input
                  placeholder="Address"
                  style={{
                    border: "1px solid #F1F0F5",
                    fontFamily: "'Open Sans', sans-serif",
                    borderRadius: "24px",
                    height: "36px",
                    width: matches380 ? "100%": "350px",
                    padding: "10px",
                    borderTop: bankAddressError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                  }}
                  disabled={isEdit}
                  value={bankAddress}
                  onChange={(e: any) => setBankAddress(e.target.value)}
                  onBlur={disableBankBtn}
                />
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                // style={{
                //   width: props.isNotFromMyWallet ? '472px' : '',
                //   margin: props.isNotFromMyWallet ? '10px auto' : '',
                //   marginTop: props.isNotFromMyWallet ? '0px' : ''
                // }}
                // className={props.isNotFromMyWallet ? '' : classes.cardContainer}
              >
                {/* <div className={classes.cardContainer}> */}
                <input
                  placeholder="City"
                  name="city"
                  type="text"
                  style={{
                    border: "1px solid #F1F0F5",
                    borderRadius: "24px",
                    height: "36px",
                    width: matches380 ? "50%": "170px",
                    padding: "15px",
                    borderTop: bankCityError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                  }}
                  value={bankCity}
                  onChange={(e) => setBankCity(e.target.value)}
                  onBlur={disableBankBtn}
                />
                {/* </div> */}
                <div placeholder="State">
                  <select
                    placeholder="State"
                    style={{
                      border: "1px solid #F1F0F5",
                      borderRadius: "24px",
                      height: "36px",
                      width: matches380 ? "100%": "170px",
                      padding: "0 15px",
                      borderTop: bankStateError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                    }}
                    defaultValue={bankState}
                    onChange={(e) => setBankState(e.target.value)}
                    onBlur={disableBankBtn}
                  >
                    <option style={{ height: "36px" }} value=''>
                      {`Select State`}
                    </option>
                    {bankCountry === "US" ? (
                      approvedStates.map((stateRecord) => (
                        <option style={{ height: "36px" }} key={stateRecord.Code} value={stateRecord.Code}>
                          {stateRecord.State + " - " + stateRecord.Code}
                        </option>
                      ))
                    ) : bankCountry === "CA" ? (
                      approvedProvinces.map((provinceRecord) => (
                        <option style={{ height: "36px" }} key={provinceRecord.Code} value={provinceRecord.Code}>
                          {provinceRecord.Province + " - " + provinceRecord.Code}
                        </option>
                      ))
                    ) : (
                      <option style={{ height: "36px" }} value="NA">
                        other
                      </option>
                    )}
                  </select>
                </div>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                // className={props.isNotFromMyWallet ? '' : classes.cardContainer}
                // style={{
                //   width: props.isNotFromMyWallet ? '472px' : '',
                //   margin: props.isNotFromMyWallet ? '10px auto' : '',
                //   marginTop: props.isNotFromMyWallet ? '0px' : ''
                // }}
              >
                {/* <div className={classes.cardContainer}> */}
                <input
                  placeholder="ZIP"
                  style={{
                    border: "1px solid #F1F0F5",
                    borderRadius: "24px",
                    height: "36px",
                    width: matches380 ? "50%": "170px",
                    padding: "0 15px",
                    borderTop: bankZipError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                  }}
                  name="zip"
                  type="text"
                  value={bankZip}
                  onChange={(e) => setBankZip(e.target.value)}
                  onBlur={disableBankBtn}
                />
                {/* </div> */}
                <div placeholder="Country">
                  <select
                    placeholder="Country"
                    style={{
                      border: "1px solid #F1F0F5",
                      borderRadius: "24px",
                      height: "36px",
                      width: matches380 ? "100%": "170px",
                      padding: "0 15px",
                      borderTop: bankCountryError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                    }}
                    defaultValue={bankCountry}
                    onChange={(e) => {
                      setBankCountry(e.target.value);
                      setBankState('');
                    }}
                    onBlur={disableBankBtn}
                  >
                    {approvedCountries.map((countryRecord) => (
                      <option style={{ height: "36px" }} key={countryRecord.Code} value={countryRecord.Code}>
                        {countryRecord.Country + " - " + countryRecord.Code}
                      </option>
                    ))}
                  </select>
                </div>
              </Stack>

              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ marginBottom: "15px" }}>
                <div className={classes.wrapper}>
                  {isEdit ? (
                    <React.Fragment>
                      <Button variant="contained" id="delete-payment" onClick={deleteBankHandler} disabled={isFetching}>
                        Delete
                      </Button>
                    </React.Fragment>
                  ) : (
                    <></>
                  )}
                </div>
                <div className={classes.wrapper}>
                  {isEdit ? (
                    <Button variant="contained" id="add-bank-btn" onClick={handleEdit} style={{ width: "120px" }}>
                      Edit Account
                    </Button>
                  ) : (
                    <React.Fragment>
                      <Button variant="contained" id="add-bank-btn" disabled={disableBankSubmit || isFetching} onClick={updateBankHandler}>
                        Save
                      </Button>
                    </React.Fragment>
                  )}
                </div>
              </Stack>
            </React.Fragment>
          </Stack>
        </Box>
      </Modal>
      {isSpinnerModalOpen ? <SpinnerModal isInvisible={true} width={"472px"} height={isOnMobileScreen ? "100%" : "610px"} openSpinnerModal={isSpinnerModalOpen} handleCloseSpinnerModal={handleCloseSpinnerModal} spinnerStatus={spinnerStatus} closeCancel={props.handleClose} /> : <></>}
    </div>
  );
}
